module.exports = __webpack_public_path__ + "img/mobile_cover_image.53da4002.svg";